<script>
   /**************************************************************/
   /* Svelte component for ExtremePlot settings                  */
   /**************************************************************/

   import Container from '../../../shared/controls/Container.svelte';
   import Select from '../../../shared/controls/Select.svelte';

   export let params;
   export let res;

   let resID = 'both';

   $: params = {
      resID
   }
</script>

{#if res  }
<Container label="">
   <p class="title">Extremes plot</p>
</Container>
{#if Object.keys(res).length > 1 }
<Container label='Results:'>
   <Select id='resType' bind:value={resID} options={[...Object.keys(res), 'both']} />
</Container>
{/if}
{/if}
